import React from 'react';
// import Add from '@material-ui/icons/Add';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Done from '@material-ui/icons/Done';
import {
  withStyles,
  Fab,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './styles';
import {
  updateMaintenanceList,
  restoreOriginalMaintenance,
} from '~/store/dailyparts/actions';

const Header = ({
  classes,
}) => {
  const isMaintenanceListDirty = useSelector(state => state.dailyParts.isMaintenanceListDirty);
  const maintenanceList = useSelector(state => state.dailyParts.maintenanceList);
  const filters = useSelector(state => state.dailyParts.filters);
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();

  return (
    <div
      // className="container"
      style={{
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 25px',
      }}
    >
      <Typography variant="h4">
        {translate('common:Cycles')}
      </Typography>
      <div>
        <Fab
          variant="extended"
          size="medium"
          color="primary"
          onClick={() => dispatch(restoreOriginalMaintenance())}
          className={classes.buttonWhiteText}
          disabled={!isMaintenanceListDirty}
        >
          <DeleteOutline />
          {translate('common:DiscardChanges')}
        </Fab>
        <Fab
          variant="extended"
          size="medium"
          color="secondary"
          onClick={() => dispatch(updateMaintenanceList(maintenanceList, filters))}
          className={classes.buttonWhiteText}
          disabled={!isMaintenanceListDirty}
        >
          <Done />
          {translate('common:End')}
        </Fab>
      </div>
    </div>
  );
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

Header.defaultProps = {};

export default withStyles(styles)(Header);
